export default __webpack_public_path__ + "static/pideloatupuerta-e0024ca5eb610d5bf605fddc174b6177.png";